import React, { createContext, useContext, useEffect, useState } from "react";
import { getAdminMe } from "../features/admin/api";

const Ctx = createContext({
  status: "unknown",
  user: null,
  refresh: async () => {},
});

export function AdminSessionProvider({ children }) {
  const [status, setStatus] = useState("unknown");
  const [user, setUser] = useState(null);

  const refresh = async () => {
    try {
      const me = await getAdminMe();
      if (me && me.role === "admin") {
        setUser(me);
        setStatus("authed");
      } else {
        setUser(null);
        setStatus("none");
      }
    } catch {
      setUser(null);
      setStatus("none");
    }
  };

  // initial load + visibility refetch
  useEffect(() => {
    refresh();
  }, []);
  useEffect(() => {
    const onVis = () => {
      if (document.visibilityState === "visible") refresh();
    };
    window.addEventListener("visibilitychange", onVis);
    return () => window.removeEventListener("visibilitychange", onVis);
  }, []);

  // Listen for cross-tab login pings
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "bb_admin_auth_event") refresh();
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  return React.createElement(
    Ctx.Provider,
    { value: { status, user, refresh } },
    children,
  );
}

export function useAdminSession() {
  return useContext(Ctx);
}

/** Emit when admin login completes (call after successful login UI flow). */
export function emitAdminLoginPing() {
  try {
    localStorage.setItem("bb_admin_auth_event", String(Date.now()));
  } catch {}
}
